export const formatLocalDateToUtcTime = date => {
    if (!date) return null;
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
};

export const parseUtcTimeToLocalDate = timeStr => {
    if (!timeStr) return null;
    const [hours, minutes] = timeStr.split(':').map(Number);
    const d = new Date();
    d.setUTCHours(hours, minutes, 0, 0);
    return d;
};
